import { commissionAccountCode, type EmploymentBond } from '@hue/contracts';

/// A conta do plano dita em palavras: o código sozinho não diz nada a quem preenche a ficha.
export function commissionAccountLabel(bond: EmploymentBond, offPayroll: boolean): string {
  const code = commissionAccountCode(bond, offPayroll);
  if (code === '4.1.3') return '4.1.3 Comissões de profissionais';
  if (code === '4.1.7') return '4.1.7 Comissões fora da folha';
  if (code === '4.4.4') return '4.4.4 Comissões de autônomos e PJ';
  return 'Conta própria, escolhida com o contador';
}
